// @ts-nocheck
import React from "react";
import { Container, Draggable, DropResult } from "@edorivai/react-smooth-dnd";
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  Typography,
} from "@mui/material";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props<T> {
  items: T[];
  itemComponent: (item: T, index: number) => React.ReactNode;
  addButtonLabel?: string;
  cellStyle?: object;
  onAdd?: () => void;
  onDrop?: (dropResult: DropResult) => void;
  onDelete?: (index: number) => void;
  emptyMessage?: string;
  disabled?: boolean;
}

const SortableList = <T extends object>({
  items,
  itemComponent,
  addButtonLabel,
  cellStyle,
  onAdd,
  onDrop,
  onDelete,
  emptyMessage,
  disabled,
}: Props<T>) => {
  return (
    <Box>
      <List>
        {items && items.length ? (
          items.map((item, index) => (
            <Box key={index} sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  pb: "20px",
                }}
              >
                <Box
                  sx={{
                    flexGrow: "1",
                    flexBasis: "0",
                  }}
                >
                  <ListItem>{itemComponent(item, index)}</ListItem>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexGrow: "1",
                    flexBasis: "0",
                  }}
                >
                  {onDelete ? (
                    <IconButton
                      size="small"
                      onClick={() => {
                        onDelete(index);
                      }}
                      disabled={disabled}
                    >
                      <DeleteIcon />
                    </IconButton>
                  ) : null}

                  {onDrop ? (
                    <ListItemIcon className="drag-handle">
                      <DragHandleIcon />
                    </ListItemIcon>
                  ) : null}
                </Box>
              </Box>
            </Box>
          ))
        ) : (
          <Box textAlign="center">
            <Typography>
              {emptyMessage ? emptyMessage : "No items available"}
            </Typography>
          </Box>
        )}
      </List>

      {onAdd ? (
        <Box textAlign="center">
          <hr />
          {addButtonLabel ? (
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<AddIcon />}
              style={{ marginTop: "10px" }}
              onClick={() => {
                onAdd();
              }}
              disabled={disabled}
            >
              {addButtonLabel}
            </Button>
          ) : (
            <IconButton
              size="small"
              onClick={() => {
                onAdd();
              }}
              disabled={disabled}
            >
              <AddIcon />
            </IconButton>
          )}
        </Box>
      ) : null}
    </Box>
  );
};

export default SortableList;
